import axios from '../plugins/axios';

export default {
  // todo: url env 등등 url 정해지면 공통변수 등록하기
  getAdminStrapi() {
    const url = process.env.VUE_APP_HIWORKS_BANNER_API + `/banners/gnb`;
    return axios.get(url);
  },

  getPlatformBanner() {
    const url = process.env.VUE_APP_HIWORKS_BANNER_API + `/banners/platform`;
    return axios.get(url);
  },
};
